import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MeasureReference } from 'src/app/domain/GS/measure-reference';
import { MasterDataService } from 'src/app/services/GS/master-data.service';
import { MeasureService } from 'src/app/services/measure.service';
import { NotificationManager } from '../notification-manager';
import { Agency } from 'src/app/domain/agency';
import { User } from 'src/app/domain/user';
import { CalendarUser } from 'src/app/components/my-calendar/day-view-scheduler.component';
import { LoadingTask } from '../loading-task';
import { UserService } from 'src/app/services/user.service';
import { CoreData } from '../../core-data/core-data';
import { MatSelectChange } from '@angular/material/select';
import * as _ from 'lodash';

@Component({
    selector: 'agency-and-technician-selection-box',
    templateUrl: 'agency-and-technician-selection-box.html',
    styleUrls: ['./agency-and-technician-selection-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AgencyAndTechnicianSelectionDialog implements OnInit {

    AgencyList: Agency[] = [];
    SelectedAgency?: Agency;
    TechnicianList: User[] = [];
    SelectedTechnicianList: CalendarUser[] = [];
    colors: any = {
        red: {
            primary: '#ad2121',
            secondary: '#FAE3E3',
        },
        blue: {
            primary: '#1e90ff',
            secondary: '#D1E8FF',
        },
        yellow: {
            primary: '#e3bc08',
            secondary: '#FDF1BA',
        },
    };
    ReducedMode: boolean = false;

    constructor(
        private coreData: CoreData,
        private userService: UserService,
        public dialogRef: MatDialogRef<AgencyAndTechnicianSelectionDialog>,
        public LoadingTask: LoadingTask,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data) {
            this.ReducedMode = data;
        }
    }

    ngOnInit() {
        this.SelectedTechnicianList = this.coreData.SamplerList;
        this.getAgencyList()
    }

    getAgencyList() {
        this.userService.getUserAgencyList().subscribe(x => {
            this.AgencyList = x;
            this.checkAgencyInLocalData();
        });
    }
    checkAgencyInLocalData() {
        if (this.coreData.Agency) {
            this.SelectedAgency = this.coreData.Agency;
            this.getSamplerOfSelectedAgency();
        }
    }
    getSamplerOfSelectedAgency() {
        if (!this.SelectedAgency)
            return;
        if (this.coreData.Agency?.AnalyticalUnitCode !== this.SelectedAgency.AnalyticalUnitCode) { // Clean only when changing agency
            this.coreData.Agency = this.SelectedAgency;
            this.TechnicianList = [];
            this.SelectedTechnicianList = [];
            this.coreData.SamplerList = [];
        }
        this.userService.getSamplerByAgencyList(this.SelectedAgency.AnalyticalUnitCode).subscribe(x => {
            this.TechnicianList = x;
        });
    }

    getSelectedTechnicien(event: MatSelectChange) {
        if (this.LoadingTask.IsLoading > 0) {
            event.source.writeValue(0);
            return;
        }

        let users: [] = event.value;
        this.SelectedTechnicianList = _.intersectionBy(this.coreData.SamplerList, users, 'Puid')
        let i = this.SelectedTechnicianList.length;

        console.log('USERS' + users.length)
        users.forEach((x: User) => {

            if (!this.SelectedTechnicianList.find(y => y.Puid === x.Puid)) {

                this.SelectedTechnicianList.push({
                    id: i++,
                    name: `${x.FirstName} ${x.LastName}`,
                    Puid: x.Puid,
                    color: this.colors.blue,
                    reducedMode: this.ReducedMode
                    // fan: counters.Fan,
                    // processMeasure: counters.ProcessMeasure,
                    // pumpWithBattery: counters.PumpWithBattery,
                    // pumpWithoutBattery: counters.PumpWithoutBattery
                })
            }
        })

        for (let j = 1; j <= this.SelectedTechnicianList.length; j++) {
            this.SelectedTechnicianList[j - 1].id = j;
            this.SelectedTechnicianList[j - 1].reducedMode = this.ReducedMode
        }
        this.coreData.SamplerList = this.SelectedTechnicianList;

    }

    public compareAgencyWith(m1: Agency, m2: Agency) {
        return m1 && m2 ? m1.AnalyticalUnitCode === m2.AnalyticalUnitCode : m1 === m2;
    }

    public compareUserWith(m1: CalendarUser, m2: CalendarUser) {
        return m1 && m2 ? m1.Puid === m2.Puid : m1 === m2;
    }

    onCancel() {
        this.dialogRef.close();
    }

    finish() {

        this.dialogRef.close({ selectedAgency: this.SelectedAgency, selectedTechnicianList: this.SelectedTechnicianList });

    }
}
